module.exports = __webpack_public_path__ + "img/master-card.33c66221.svg";